import app from './app'
import { initializeFirestore } from 'firebase/firestore'

const firestore = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  useFetchStreams: false
})

export default firestore
